module.exports = __webpack_public_path__ + "img/tel_4.13c7db20.png";